import moment from 'moment';
import { getSearchDateParamFromMoment } from 'utils/search/searchDateParam';

/**
 * Builds the search URL to leave the quick purchase creation screen.
 * Uses only the search slice — does not read purchase state.
 * @param {object} params - URL builder params.
 * @param {object} params.search - Redux search state.
 * @param {string} params.passengersParam - Encoded passengers route param.
 * @param {object} params.features - Whitelabel feature flags.
 * @returns {string|null} Search URL or null when required data is missing.
 */
export default function buildQuickPurchaseExitSearchUrl({ search, passengersParam, features }) {
  const { originId, destinationId, departureDate, returnDate, hybridTrip } = search;

  if (!originId || !destinationId || !departureDate) {
    return null;
  }

  const departureIsOpenTicket = hybridTrip === 'departure' || hybridTrip === 'both';
  const returnIsOpenTicket = hybridTrip === 'return' || hybridTrip === 'both';

  const formattedDeparture = departureIsOpenTicket
    ? moment(departureDate, 'DD-MM-YYYY').format('DD-MMM-YY')
    : getSearchDateParamFromMoment(moment(departureDate, 'DD-MM-YYYY'));

  let url = `/search/${originId}/${destinationId}/${formattedDeparture}/`;

  if (returnDate) {
    const formattedReturn = returnIsOpenTicket
      ? moment(returnDate, 'DD-MM-YYYY').format('DD-MMM-YY')
      : getSearchDateParamFromMoment(moment(returnDate, 'DD-MM-YYYY'));

    url += `${formattedReturn}/`;
  }

  const way = features.PROVIDERS_SELECTION_ENABLED ? 'providers' : 'departures';
  url += `p/${passengersParam}/${way}`;

  const queryParams = [];
  if (returnIsOpenTicket) {
    queryParams.push('returnIsOpenTicket=true');
  }
  if (departureIsOpenTicket) {
    queryParams.push('departureIsOpenTicket=true');
  }

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  return url;
}
